var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,10.717A10.818,10.818,0,0,1,5.979,20.1L0,22l1.949-5.75A10.6,10.6,0,0,1,.4,10.717a10.8,10.8,0,0,1,21.6,0ZM11.2,1.707a9.055,9.055,0,0,0-9.08,9.01A8.915,8.915,0,0,0,3.85,16L2.715,19.345,6.2,18.236A9.089,9.089,0,0,0,20.28,10.717,9.056,9.056,0,0,0,11.2,1.707Zm5.454,11.478c-.067-.109-.243-.175-.507-.307s-1.567-.767-1.809-.854-.42-.132-.6.131-.684.854-.838,1.03-.309.2-.574.066a7.246,7.246,0,0,1-2.129-1.3,7.919,7.919,0,0,1-1.473-1.819c-.154-.263-.016-.4.116-.536s.265-.307.4-.46a1.761,1.761,0,0,0,.264-.438.479.479,0,0,0-.022-.46c-.066-.131-.6-1.424-.816-1.95s-.441-.438-.6-.438-.331-.022-.507-.022a.977.977,0,0,0-.706.329,2.937,2.937,0,0,0-.926,2.191A5.083,5.083,0,0,0,7.013,11.06a10.822,10.822,0,0,0,4.522,3.966c2.692,1.051,2.692.7,3.177.657A2.678,2.678,0,0,0,16.5,14.434,2.19,2.19,0,0,0,16.654,13.185Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.16e9846e.svg";
export { ForwardRef as ReactComponent };